
jQuery(document).ready(function ($) {

    /**
     * menu : liens de premier niveau desactives (.off)
     */
    $('nav.mobile .navs > ul > li.off > a').on('click', function (event) {
        event.preventDefault();
    });



})


